import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * ProtectedRoute Component
 * Redirects to login if not authenticated
 * Optionally checks for specific role
 */
const ProtectedRoute = ({ children, requiredRole = null }) => {
  const location = useLocation();
  const { isAuthenticated, user, initialized } = useSelector((state) => state.auth);

  // Wait until initializeAuth has resolved so a stored session is not
  // treated as logged-out for the first paint.
  if (!initialized) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Determine appropriate login page based on the route being accessed
    let loginPath = '/login';
    
    if (location.pathname.startsWith('/admin')) {
      loginPath = '/admin/login';
    } else if (location.pathname.startsWith('/technician')) {
      loginPath = '/technician/login';
    }
    
    // Redirect to appropriate login page, save the attempted location
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  // Check role if specified
  const allowedRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
  if (requiredRole && !allowedRoles.includes(user?.role)) {
    // Redirect to appropriate dashboard based on user's actual role
    if (user?.role === 'customer') {
      return <Navigate to="/" replace />;
    } else if (user?.role === 'technician') {
      return <Navigate to="/technician/dashboard" replace />;
    } else if (user?.role === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    } else if (user?.role === 'viewer') {
      // View-only accounts can only open App Store Clicks.
      return <Navigate to="/admin/app-clicks" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;


